module.exports = __webpack_public_path__ + "img/heart.74914c32.png";